import React from 'react';
import {Link} from 'react-router-dom';
import classnames from 'classnames';

import styles from './styles.module.scss';

export interface CTAButtonProps {
  path: string;
  routed?: boolean;
  title: string;
  ariaLabel: string;
  outline?: boolean;
  onClick?: () => void;
}

const NavbarCTAButton = ({title, ariaLabel, outline, path, routed, onClick}: CTAButtonProps) => {
  const linkProps = {
    className: classnames('shared-button small blue', styles.CTAButton, {
      'blue-outline': outline,
    }),
    ['aria-label']: ariaLabel,
  };

  if (onClick) {
    return (
      <button onClick={onClick} {...linkProps}>
        {title}
      </button>
    );
  }

  if (routed) {
    return (
      <Link to={path} {...linkProps}>
        {title}
      </Link>
    );
  }

  return (
    <a href={path} {...linkProps}>
      {title}
    </a>
  );
};

export default NavbarCTAButton;
